function formataNumero(numero) {
    try {
        return numero.toLocaleString('pt-BR');
    } catch (error) {
        return 0;
    }
}

function formataNumeroMoeda(numero) {
    try {
        return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (error) {
        return 0;
    }
}

function retornaCabecalho(categoria) {

    let t = [
        "Consultoria em Tecnologia",
        "Metrologia",
        "Pesquisa, Desenvolvimento e Inovação",
        "Serviços Técnicos Especializados",
        "Serviços Complementares"
    ]

    let consultoriasEPDI = [
        "Consultoria em Processos Produtivos",
        "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",

        "Calibração",
        "Ensaios",

        "Pesquisa, Desenvolvimento e Inovação de Produto",
        "Pesquisa, Desenvolvimento e Inovação de Processo",

        "Consultoria em Gestão Empresarial",

        "Serviços Operacionais"
    ]

    let linhaAtuacao;
    if(categoria === "Consultoria em Processos Produtivos" || categoria === "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos") {
        linhaAtuacao = "Consultoria em Tecnologia";
    }
    else if(categoria === "Calibração" || categoria === "Ensaios") {
        linhaAtuacao = "Metrologia";
    }
    else if(categoria === "Pesquisa, Desenvolvimento e Inovação de Produto" || categoria === "Pesquisa, Desenvolvimento e Inovação de Processo") {
        linhaAtuacao = "Pesquisa, Desenvolvimento e Inovação";
    }
    else if(categoria === "Consultoria em Gestão Empresarial") {
        linhaAtuacao = "Serviços Complementares";
    }
    else if(categoria === "Serviços Operacionais") {
        linhaAtuacao = "Serviços Técnicos Especializados";
    }

    return linhaAtuacao

}

function verificaColuna(categoria) {

    let consultoriasEPDI = [
        "Consultoria em Processos Produtivos",
        "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",
        "Pesquisa, Desenvolvimento e Inovação de Produto",
        "Pesquisa, Desenvolvimento e Inovação de Processo",
        "Consultoria em Gestão Empresarial"
    ]

    let coluna;
    if(categoria === "Serviços Operacionais") {
        coluna = "numeroAtendimento";
    }
    else if(categoria === "Calibração") {
        coluna = "calibracoes";
    }
    else if(categoria === "Ensaios") {
        coluna = "ensaios";
    }
    else if(consultoriasEPDI.includes(categoria)) {
        coluna = "horasTecnicas";
    }
    
    return coluna;

}

export default { 
    formataNumero,
    retornaCabecalho,
    verificaColuna,
    formataNumeroMoeda
}